import { Country } from '@commenda/prisma';

// Unified LocationType vocabulary — matches sales-tax-api-2's location_type and
// commenda-logical-backend's LocationType enum (after the PR2 cutover).
// CONTACT_ADDRESS is logical-backend-only (used for director home addresses) and
// is not exposed in this FE-facing enum.
export enum LocationTypeRevamp {
  PRINCIPAL_PLACE_OF_BUSINESS = 'PRINCIPAL_PLACE_OF_BUSINESS',
  BRANCH_OFFICE = 'BRANCH_OFFICE',
  RETAIL_LOCATION = 'RETAIL_LOCATION',
  FACTORY = 'FACTORY',
  WAREHOUSE = 'WAREHOUSE',
  NATURAL_RESOURCE_SITE = 'NATURAL_RESOURCE_SITE',
  REGISTERED_OFFICE = 'REGISTERED_OFFICE',
  REPRESENTATIVE_OFFICE = 'REPRESENTATIVE_OFFICE',
  CONSTRUCTION_SITE = 'CONSTRUCTION_SITE',
  THIRD_PARTY_FULFILLMENT = 'THIRD_PARTY_FULFILLMENT',
  REMOTE_EMPLOYEE = 'REMOTE_EMPLOYEE',
  DEPENDENT_AGENT = 'DEPENDENT_AGENT',
  INDEPENDENT_AGENT = 'INDEPENDENT_AGENT',
  OTHER = 'OTHER',
  REGISTRATION = 'REGISTRATION',
  MAILING_ADDRESS = 'MAILING_ADDRESS',
}

export interface ILocationAddress {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  postalCode?: string;
  state?: string; // Should be ISO 3166-2 alpha state code. State is not required for all countries.
  country: Country; // ISO 3166 country code.
}

export interface ILocationOld {
  id: string;
  corporationId: number;
  locationTypes: LocationTypeRevamp[];
  address: ILocationAddress;
  name?: string;
  employeeCount?: number;
  isVirtualAddress?: boolean;
  startDate?: Date;
  createdAt: string;
  updatedAt: string;
}

export interface ILocation {
  id: string;
  corporationId: number;
  locationTypes: LocationTypeRevamp[];
  address: ILocationAddress;
  name?: string;
  employeeCount?: number;
  isVirtualAddress?: boolean;
  startDate?: Date;
  endDate?: Date;
  createdAt: string;
  updatedAt: string;
}
